module.exports = {

  title: '项目管理后台',
  //远程接口地址，主要用于图片拼接
  imageUrl: 'http://124.220.205.119:8080/api/v1/static/',
  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  //未读消息个数
  noRead: 5,

  /**
   * 项目模板
   */
   templateConfig:[
     {
      templateId: 1,
      templateName:'软件开发',
      stageNameList: ['需求沟通、整理、报价', '软件设计阶段','软件开发阶段','软件测试阶段','客户验收阶段','软件上线，运维阶段']
     },
     {
      templateId: 2,
      templateName:'硬件开发',
      stageNameList: ['用户需求收集', '项目资源评估','元器件原理分析','设计原理图','元器件选型','电路功能验证、焊接、波形调试','PCB Layout',
      'BOM制作','样板制作','编写调试代码','样板定型','产品移交用户、结案复盘']
     },
     {
      templateId: 3,
      templateName:'Web开发',
      stageNameList: ['需求沟通、整理、报价', 'UI设计','数据结构设计','开发阶段','测试阶段','客户验收阶段','代码部署，运维阶段']
     },
     {
      templateId: 4,
      templateName:'App开发',
      stageNameList: ['需求沟通、整理、报价', 'UI设计','数据结构设计','开发阶段','测试阶段','客户验收阶段','代码部署，运维阶段']
     },
     {
      templateId: 5,
      templateName:'小程序开发',
      stageNameList: ['需求沟通、整理、报价', 'UI设计','数据结构设计','开发阶段','测试阶段','客户验收阶段','代码部署，运维阶段']
     }
   ]
}
